import { formatDateIfValid } from '../formatDateIfValid';

export const formatDateToTimeDisplay = (date: Date | string | null) => {
  const formatTemplate = 'HH:mm';

  return formatDateIfValid(date, { formatTemplate, fallbackValue: ' - ' });
};
